(function () {
    'use strict';

    angular.module('ecap.registration', []);

})();